import React from 'react';
import ProjectCard from '../components/proiect-plamanul-verde-al-orasului/ProjectCard';

function ProiectPlamanulVerdeAlOrasuluiPage() {
  return <ProjectCard />;
}

export default ProiectPlamanulVerdeAlOrasuluiPage;
